/* 布局 */
//前台
import Layout from "@views/layout";

const plastucurriculumchapterRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "plastucurriculumchapter/list/:id",
        name: "PLASTUCURRICULUMCHAPTER",
        meta: {
            title: "学生课程章节",
        },
        component: () => import("@views/business/plastucurriculumchapter/index.vue"),
    },
        ],
};

export default plastucurriculumchapterRouter;
